import Moment from 'moment';
import { useContext, useState } from "react";
import { useLoaderData, useLocation, useNavigate } from "react-router-dom";
import Button from "../../../../components/UI/Button/Button";
import FileBoxMj from "../../../../components/UI/Input/FileBoxMj";
import Input from "../../../../components/UI/Input/Input";
import Radio from "../../../../components/UI/Input/Radio";
import { JwtTokenContext } from "../../../../store/JwtTokenProvider";
import classes from "../../MngCommon.module.css";
import { ReqCatalogueCreate, ReqCatalogueDetail, ReqCatalogueUpdate } from '../../../../api/site/ApiForCatalogue';
import FileBoxUpdateMj from '../../../../components/UI/Input/FileBoxUpdateMj';

function MngCatalogueModify() {

    const catalogue = useLoaderData();

    const location = useLocation();
    const navigate = useNavigate();

    const backHandler = () => {
        navigate("/admin/site/catalog", { state: location.state });
    };

    const [exposeYn, setExposeYn] = useState(catalogue.exposeYn);
    const [title, setTitle] = useState(catalogue.title);
    const [file, setFile] = useState();
    const [fileName, setFileName] = useState(catalogue.attachFile != null ? catalogue.attachFile.originalFileName : "");

    const changeTitleHandler = (value) => {
        setTitle(value);
    };

    const exposeYnRadioButton = (e) => {
        setExposeYn(e.target.value)
    }

    const handleFileChange = (file) => {
        setFile(file);
        setFileName(file ? file.name : "");
    };

    const updateHandler = async (e) => {
        e.preventDefault();
        
        if(!title) {
            alert("카달로그명을 입력해주세요.");
            return
        }

        if(!fileName) {
            alert("첨부파일을 등록해주세요.");
            return
        }

        const isTrue = window.confirm('내용을 수정하시겠습니까?');
        if(isTrue) {
            try {
                const jsonData = JSON.stringify({
                    exposeYn: exposeYn,
                    title: title,
                    attach_uri : file ? null : catalogue.attach_uri,
                });

                const formData = new FormData();
      
                if (file) {
                    formData.append("file", file);
                }
            
                formData.append("body", new Blob([jsonData], { type: "application/json" }));

                const response = await ReqCatalogueUpdate(catalogue.id, formData);
                if (response.status === 200) {
                    alert("내용이 수정되었습니다.");
                    backHandler();
                } else {
                    alert("내용 수정 실패");
                }
            } catch (error) {
                console.error("Error:", error);
            }
        } else {
          return
        }

        
    };

    return (
        <section>
            <div className={classes.admin_contents}>
                <h3>카탈로그 - 수정</h3>
                <div
                    className={`${classes.contents_wrap} ${classes.search_wrap} `}
                >
                    <div className={classes.admin_table_wrap}>
                        <table>
                            <colgroup>
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "40%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "40%" }} />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>등록일</th>
                                    <td>{Moment(catalogue.regDate).format('YYYY-MM-DD')}</td>
                                    <th>등록자</th>
                                    <td>{catalogue.regID}</td>
                                </tr>
                                <tr>
                                    <th>노출여부</th>
                                    <td colSpan={3}>
                                        <div className={classes.radio_wrap}>
                                            <Radio
                                                value="Y"
                                                title="노출"
                                                name="rad_01"
                                                id="rad_01_01"
                                                checked={exposeYn === "Y"} 
                                                onChange={exposeYnRadioButton}
                                            />
                                            <Radio
                                                value="N"
                                                title="미노출"
                                                name="rad_01"
                                                id="rad_01_02"
                                                checked={exposeYn === "N"} 
                                                onChange={exposeYnRadioButton}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>카탈로그명</th>
                                    <td colSpan={3}>
                                        <Input
                                            className="admin_st"
                                            onChange={changeTitleHandler}
                                            value={title}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>첨부파일</th>
                                    <td colSpan={3}>
                                        <FileBoxUpdateMj
                                            onFileChange={handleFileChange}
                                            selectedFileName={fileName}
                                            file={file}
                                            setFile={setFile}
                                            setFileName={setFileName}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className={classes.bottom_btn_wrap}>
                            <Button className="secondary sm" onClick={updateHandler}>수정</Button>
                            <Button
                                className="border sm" onClick={backHandler}
                            >
                                목록
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default MngCatalogueModify;

export const loader = async ({ params }) => {
    const response = await ReqCatalogueDetail(params.catalogId);

    if (response.status === 200) {
        const resData = await response.data;

        return resData;
    } else {
        return [];
    }
};